// extracted by mini-css-extract-plugin
module.exports = {"loading":"_28lSbUu3npJtnts-Ni7Ebf","loading_svg":"_12__R27_wpUum2q55VIzi9","rotateLoading":"_3faDDeXkveD-Lhq08X4RlJ","loading_text":"_1zdJ61GwngG9o-i_PKZRT7"};